import script from "./clinic-doctors.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-doctors.vue?vue&type=script&setup=true&lang=js"

import "./clinic-doctors.vue?vue&type=style&index=0&id=27b00900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b00900"]])

export default __exports__